import axios from "axios";
import { Base_URL } from "../url";

// Save task details
export const saveTaskDetails = async (taskData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaskMaster/CreateTask`,
      taskData,
      {
        params: { UserName: userId },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save task");
  }
};

// Get all tasks (for listing page)
export const getAllTasks = async () => {
  try {
    const response = await axios.get(`${Base_URL}/TaskMaster/GetAllTasks`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch tasks");
  }
};

// Get tasks by organization
export const getTasksByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTasksByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch tasks");
  }
};

// Get task by ID
export const getTaskById = async (taskId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTaskById/${taskId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch task");
  }
};

// Update task
export const updateTask = async (taskId, taskData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/TaskMaster/UpdateTask/${taskId}`,
      taskData,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update task");
  }
};

// Get tasks by project ID
export const getTasksByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTasksByProject/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch tasks for project",
    );
  }
};

// SubTask API calls

// Create new subtask
export const createSubTask = async (subTaskData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/SubTaskMaster/CreateSubTask`,
      subTaskData,
      {
        params: { UserName: userId },
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create subtask",
    );
  }
};

// Update existing subtask
export const updateSubTask = async (subTaskId, subTaskData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/SubTaskMaster/UpdateSubTask/${subTaskId}`,
      subTaskData,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update subtask",
    );
  }
};

// Get all subtasks for a specific task
export const getSubTasksByTask = async (taskId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SubTaskMaster/GetSubTasksByTask/${taskId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch subtasks",
    );
  }
};

// Get subtask by ID
export const getSubTaskById = async (subTaskId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SubTaskMaster/GetSubTaskById/${subTaskId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch subtask");
  }
};

// Get all subtasks
export const getAllSubTasks = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/SubTaskMaster/GetAllSubTasks`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch subtasks",
    );
  }
};

// Export subtasks to Excel
export const exportSubTasksToExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/SubTaskMaster/ExportSubTasksToExcel`,
      {},
      {
        responseType: "blob", // Important for file download
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to export subtasks",
    );
  }
};

// Get tasks by projectId AND stageBelong
export const getTasksByProjectAndStage = async (projectId, stageBelong) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTasksByProjectAndStage`,
      {
        params: {
          projectId: projectId,
          stageBelong: stageBelong,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch tasks for project and stage",
    );
  }
};

// Upload Excel file to create multiple tasks
// TaskMaster.js - Update the createTasksFromExcel function
export const createTasksFromExcel = async (formData) => {
  try {
    console.log("Sending Excel upload request...");
    const response = await axios.post(
      `${Base_URL}/TaskMaster/CreateTasksFromExcel`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 30000, // 30 second timeout
      },
    );

    console.log("API Response:", response);
    console.log("Response data:", response.data);

    // Check if response has data property
    return response.data || response;
  } catch (error) {
    console.error("=== FULL API ERROR ===");
    console.error("Error object:", error);
    console.error("Response:", error.response);
    console.error("Request:", error.request);
    console.error("Config:", error.config);

    // Log the complete error response
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response headers:", error.response.headers);
      console.error("Response data:", error.response.data);

      // Try to parse the error data
      const errorData = error.response.data;
      console.error("Parsed error data:", JSON.stringify(errorData, null, 2));

      let errorMessage = "Failed to create tasks from Excel";

      if (errorData) {
        if (typeof errorData === "string") {
          errorMessage = errorData;
        } else if (errorData.message) {
          errorMessage = errorData.message;
          if (errorData.error) {
            errorMessage += `: ${errorData.error}`;
          }
          if (errorData.innerError) {
            errorMessage += ` (${errorData.innerError})`;
          }
        } else if (errorData.error) {
          errorMessage = errorData.error;
        }
      }

      throw new Error(errorMessage);
    } else if (error.request) {
      console.error("No response received:", error.request);
      throw new Error(
        "No response from server. Please check your network connection.",
      );
    } else {
      console.error("Error setting up request:", error.message);
      throw new Error(`Request error: ${error.message}`);
    }
  }
};

// ======================= 🧩 Task Assignment Tracking APIs =======================

/**
 * Start work on a specific task for a user
 * @param {string} taskId - The task ID
 * @param {string} userId - The user assigned to work
 * @param {string} orgId - The organization ID (optional)
 */
export const startTaskWork = async (taskId, userId, orgId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaskAssignmentTracking/StartWork`,
      {
        TaskId: taskId,
        AssignedUserId: userId,
        OrgId: orgId?.toString(),
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error starting task work:", error);
    throw new Error(
      error.response?.data?.message || "Failed to start work on task",
    );
  }
};

/**
 * Stop work for a specific assignment
 * @param {string} assignmentId - The assignment ID of the active session
 */
export const stopTaskWork = async (assignmentId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaskAssignmentTracking/StopWork/${assignmentId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error stopping task work:", error);
    throw new Error(
      error.response?.data?.message || "Failed to stop work session",
    );
  }
};

export const pauseTaskWork = async (assignmentId) => {
  const response = await axios.post(
    `${Base_URL}/TaskAssignmentTracking/PauseWork/${assignmentId}`,
  );
  return response.data;
};

/**
 * Get all assignments (sessions) for a specific task
 * @param {string} taskId - The task ID
 */
export const getTaskAssignmentsByTaskId = async (taskId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskAssignmentTracking/GetByTaskId/${taskId}`,
    );
    console.log("Response data:", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching assignments for task ${taskId}:`, error);
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch task assignment details",
    );
  }
};

/**
 * ✅ Get tasks assigned to a user within an organization
 * @param {string} userId - Assigned User ID
 * @param {string} orgId - Organization ID
 */
export const getTasksByUserAndOrg = async (userId, orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskAssignmentTracking/GetTasksByUserAndOrg/${userId}/${orgId}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching tasks for user ${userId} in org ${orgId}:`,
      error,
    );
    throw new Error(
      error.response?.data?.message || "Failed to fetch tasks for the user",
    );
  }
};

/**
 * Get all active task sessions (useful for monitoring active users)
 */
export const getActiveTaskAssignments = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskAssignmentTracking/GetActiveAssignments`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching active task assignments:", error);
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch active task assignments",
    );
  }
};

export const createTaskWorkLog = async (payload) => {
  const res = await axios.post(`${Base_URL}/TaskGuidLog/Create`, payload);
  return res.data;
};

export const getTaskLogsByTaskId = async (taskId) => {
  const res = await axios.get(`${Base_URL}/TaskGuidLog/GetByTask/${taskId}`);
  return res.data;
};

// ======================= 📝 Task Remarks =======================

// Add remark to task
export const addTaskRemark = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TaskMaster/AddTaskRemark`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to add task remark",
    );
  }
};

// Get remarks by task
export const getTaskRemarks = async (taskId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskMaster/GetTaskRemarks/${taskId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch task remarks",
    );
  }
};

// ✅ Get Task List by Assigned User (MULTI-ASSIGNMENT SUPPORT)
export const getTaskListByAssignedUser = async (userId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskAssignmentTracking/GetTaskListByAssignedUser/${userId}`,
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching tasks for user ${userId}:`, error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch assigned task list",
    );
  }
};

// ======================= 📌 Task Status APIs =======================

// Get all status (for dropdown)
export const getAllTaskStatus = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskStatusMaster/GetAllStatus`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch task status",
    );
  }
};

// Get status by GUID
export const getTaskStatusByGuid = async (statusGuid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/TaskStatusMaster/GetStatusByGuid/${statusGuid}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch status details",
    );
  }
};
